import { render, staticRenderFns } from "./OrderProductsFilter.vue?vue&type=template&id=487791ee&"
import script from "./OrderProductsFilter.vue?vue&type=script&lang=js&"
export * from "./OrderProductsFilter.vue?vue&type=script&lang=js&"
import style0 from "./OrderProductsFilter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports